import styles from './stats.module.css';

/** Titled block on a stats screen: muted kicker label above the cards. */
const StatsSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
    <section className={styles.section}>
        <div className={styles.sectionLabel}>{title}</div>
        {children}
    </section>
);

export default StatsSection;
